import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';
type Size = 'md' | 'lg';

type Props = {
  variant?: Variant;
  size?: Size;
  fullWidth?: boolean;
  childColor?: boolean;
  children: ReactNode;
} & ButtonHTMLAttributes<HTMLButtonElement>;

const sizeClasses: Record<Size, string> = {
  md: 'h-11 px-5 text-[14px]',
  lg: 'h-14 px-6 text-[16px]',
};

export function Button({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  childColor = false,
  className = '',
  children,
  ...rest
}: Props) {
  let variantClasses = '';
  if (variant === 'primary') {
    variantClasses = childColor
      ? 'bg-child-accent text-ink-inverse'
      : 'bg-ink text-ink-inverse';
  } else if (variant === 'secondary') {
    variantClasses = childColor
      ? 'border-hairline border-child-accent/40 text-child-accent bg-transparent'
      : 'border-hairline border-border-strong text-ink bg-transparent';
  } else if (variant === 'ghost') {
    variantClasses = 'text-ink-muted bg-transparent';
  } else {
    variantClasses = 'bg-danger text-ink-inverse';
  }

  return (
    <button
      className={[
        'inline-flex items-center justify-center rounded-md font-medium transition active:scale-[0.98] disabled:opacity-40 disabled:pointer-events-none',
        sizeClasses[size],
        variantClasses,
        fullWidth ? 'w-full' : '',
        className,
      ].join(' ')}
      {...rest}
    >
      {children}
    </button>
  );
}
